import { ProgramRequestStatus } from "../../../models/ProgramRequest/ProgramRequestStatus";

export const canInstitutionRevokeRequest = (
  isMinister: boolean,
  statusId: ProgramRequestStatus,
): boolean => {
  if (isMinister) {
    return (
      statusId === ProgramRequestStatus.SubmittedMZO ||
      statusId === ProgramRequestStatus.UnlockedMZO
    );
  }

  return (
    statusId === ProgramRequestStatus.SubmittedASOO ||
    statusId === ProgramRequestStatus.SubmittedMZO ||
    statusId === ProgramRequestStatus.UnlockedASOO ||
    statusId === ProgramRequestStatus.UnlockedMZO
  );
};

